export const pageWidths = {
  largeWidth: 1500,
  mediumWidth: 1150,
  smallWidth: 767,
};
